<script lang="ts">
import {defineComponent, PropType} from 'vue'
import {GlobalFilterChangeEvent, GlobalFilterType, GlobalFilterTypesType} from "./GlobalFilterType";
import SalFilterSelect from "@productfinder/components/sal-filter-select/sal-filter-select.vue";
import SalFilterGroupedselect from "@productfinder/components/sal-filter-groupedselect/sal-filter-groupedselect.vue";
import GlobalFilterSelect from "@global/global-elements/global-filter-select/global-filter-select.vue";

export default defineComponent({
    name: "global-filter",
    computed: {
        GlobalFilterTypeType() {
            return GlobalFilterTypesType
        }
    },
    components: {GlobalFilterSelect, SalFilterGroupedselect, SalFilterSelect},
    props: {
        filter: {
            type: Object as PropType<GlobalFilterType>,
            required: true
        }
    },
    methods: {
        handleOptionChange(change: GlobalFilterChangeEvent) {
            this.$emit('change', change)
        }
    }
})
</script>

<template>
    <global-filter-select v-if="filter.type === GlobalFilterTypeType.SELECT" :filter="filter" @changeOption="handleOptionChange"></global-filter-select>
    <global-filter-select v-else-if="filter.type === GlobalFilterTypeType.GROUPED_SELECTION" :filter="filter" @changeOption="handleOptionChange"></global-filter-select>
</template>
